module.exports = __webpack_public_path__ + "img/ergediandian-sp.5bce5af1.webp";